// Vendors
import { wasSuccessRequest } from '@openbank/cf-ui-framework';
// Services
import { getProofIncomeMethodUrlService } from '../services/proof-income-landing.services';
// Types
import { ProofIncomeContextType } from 'containers/proof-income/contexts/types/proof-income-landing.contexts.type';
import {
  IdentificationApiResponseErrorType,
  IdentificationApiResponseType,
} from 'types/identification-api-response.type';

const getProofIncomeMethodUrlResolver = async (
  method: ProofIncomeContextType['selectedMethod']
): Promise<
  [IdentificationApiResponseType, false] | [[IdentificationApiResponseErrorType, Response], true]
> => {
  const [data, response] = await getProofIncomeMethodUrlService(method);

  return wasSuccessRequest(response.status)
    ? [data as IdentificationApiResponseType, false]
    : [[data as IdentificationApiResponseErrorType, response], true];
};

export { getProofIncomeMethodUrlResolver };
